import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { BasicGroup } from "config/constants.config";
import { buildUpdatingEstimateBasicItemsSelector } from "store/entities/estimates";

import ItemsWrapper from "../ItemsWrapper/ItemsWrapper";
import { useAssociatedItems } from "common/hooks/useAssociatedItems";
import InfoBanner from "../ItemsStep/InfoBanner";


export default function MaterialsStep({ estimate, patch }) {
  const materialsSelector = useMemo(
    () => buildUpdatingEstimateBasicItemsSelector(BasicGroup.MATERIALS),
    [estimate.id, estimate.type]
  );
  const estimateMaterials = useSelector(materialsSelector);
  const { loaded } = useAssociatedItems(); // catalog must be loaded before names/prices can be shown (it is not when the wizard opens on another step)

  const hasMaterials = (estimate.materials || []).length > 0;

  if (!loaded)
    return <div style={{ padding: 24 }}>Loading items...</div>;

  return (
    <>
    {hasMaterials && (
      <InfoBanner title="Delivery">
        A $120 delivery line (DELIVERY ALLOWANCE) is added automatically when you save if the materials subtotal (before tax, not counting delivery) is over $500.
        For pickup set its quantity to 0. Minimum one box of nails and one box of staples is also added automatically on shingle jobs.
      </InfoBanner>
    )}
    <ItemsWrapper
      estimate={estimate}
      patch={patch}
      data={estimateMaterials}
      group={BasicGroup.MATERIALS}
      entityName="material"
    />
    </>
  );
}
